import { render, staticRenderFns } from "./NegativeBalanceTable.vue?vue&type=template&id=fbe20966&scoped=true"
import script from "./NegativeBalanceTable.vue?vue&type=script&lang=js"
export * from "./NegativeBalanceTable.vue?vue&type=script&lang=js"
import style0 from "./NegativeBalanceTable.vue?vue&type=style&index=0&id=fbe20966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe20966",
  null
  
)

export default component.exports